<template>
    <div class="gray-back" >
        <div class="box">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-if="haveResult"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div class="kaojicenter-list-box">
                        <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"
                             @click="onDownload(item, index)">
                            <div class="kaojicenter-rights">
                                <div class="title">{{item.saiqu_name}}</div>
                                <div class="desc flex-start">
                                     {{item.mingcheng}}<br/>
                                    {{item.name}} ({{item.num}})
                                </div>
                            </div>
                            <div class="kaojicenter-lefts">
                                下载证书
                            </div>
                        </div>
                    </div>
                    </van-list>
                </van-list>
            </van-pull-refresh>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="addShow=true">查询</van-button>
            </div>


            <van-popup
                    position="bottom"
                    :style="{ height: '50%' }"
                    v-model="addShow"
                    @click-overlay="addShow=false"
            >
                <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
                    <van-form
                            @submit="onSubmit"
                            @failed="onFailed"
                    >
                    <van-divider>如您获得纸质证书，则不提供电子证书下载</van-divider>
                    <van-cell-group>
                        <van-field
                                v-model="params.name"
                                label="教练姓名"
                                :rules="[{ required: true, message: '姓名不能为空' }]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入姓名"
                        />

                        <van-field
                                v-model="params.num"
                                label="证件号码"
                                :rules="[{ required: true, message: '证件号码不能为空' }]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入证件号码"
                        />


                    </van-cell-group>

                    <div class="savebtn">
                        <van-button
                                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                                style="width: 3rem"
                                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." native-type="submit" >查询</van-button>
                    </div>
                    </van-form>
                </div>
            </van-popup>


        </div>


        <van-popup v-model="showCert" style="width: 80%; height: auto ; text-align: center">
            <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
            <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
            <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
        </van-popup>

        <van-overlay :show="certLoading"    >
            <van-loading type="spinner" v-model="certLoading" style="text-align: center ; margin-top: 200px;" />
        </van-overlay>
    </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .kaojicenter-list-box {
        padding-top: 0.2rem;
        /*background: rgba(248,248,248,1);*/
    }

    .goods-line {
        height: 55px;
    }

    .goods-bottom-line {
        width: 100%;
        position: fixed;
        height: 60px;
        bottom: 0;
        background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
    }

    .goods-create-btn {
        position: fixed;
        bottom: 10px;
        width: 100%;
        height: 44px;
        font-size: 16px;
        text-align: center;
    }

    .goods-create-btn button {
        width: 3.2rem;
    }

    .goods-create-btn img {
        width: 60px;
        height: 60px;
    }

    .goods-header {
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        z-index: 99;
        width: 100%;
        margin-bottom: 0.01rem;
        background: #fff;
    }

    .van-tabs {
        width: 85% !important;
    }

    .screen-btn {
        line-height: 44px;
        height: 44px;
    }

    .screen-btn img {
        width: 45%;
        padding-left: 15px;
        vertical-align: middle;
        border-left: 1px solid #D5D5D5;
    }

    .sidebar {
        padding-top: 15px;
    }

    .search-box img {
        width: 60px;
        height: 60px;
    }


    .select-btn {
        position: fixed;
        bottom: 0;
        width: 90%;
        margin: 0 auto;
        padding: 0px 15px 30px;
    }

    .btn-reset {
        padding-bottom: 10px;
    }

    .btn-reset >>> .van-button {
        background: #ddd;
    }

    .selected {
        color: #444;
    }


    .kaojicenter-lists {
        padding: 0.2rem;
        border-radius:10px;
        background: #fff;
        margin: 0 0.2rem 0.2rem;
    }

    .kaojicenter-lefts {
        position: relative;
    }


    .kaojicenter-lefts {
        border-radius: 10px;
        width: 1rem;
        color: #666;
        font-size: 12px;
        /*height: 1rem;*/
    }

    .kaojicenter-rights {
        width:calc(100% - 1.2rem);
        position: relative;
        /*height: 1rem;*/
    }

    .kaojicenter-rights .title{
        font-size: 15px;
        font-weight: bold;
    }
    .kaojicenter-rights .desc{
        font-size: 12px;
        line-height: 26px;
        padding-top: 10px;
        color: #999;
    }



</style>

<script>
    import Vue from 'vue';
    import validator from "../../../utils/validator";

    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,DatetimePicker} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
    export default {
        name: 'JiaolianList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        data: function () {
            return {
                validator,
                id: 0,
                addShow:true,
                list: [],
                params: {
                    name:'',
                    num:'',
                    pageNo: 1,
                    pageSize: 10,
                    keywords: '',
                    status: 1
                },
                showCert:false,
                certUrl:'',
                filename:'',
                saveLoading:false,
                isLoading: false,
                certLoading: false,
                loading: false,
                finished: false,
                haveResult : false,
                isApp:window.isApp()

            }
        },
        mounted() {
            document.title = "教练员证书下载"
//            this.getList();
        },
        computed:{
        },
        filters:{
            cert(value){
                switch (value){
                    case 1 :
                        return '#ff0000'
                        break;
                    case 2 :
                        return '#FF9966'
                        break;
                    case 3 :
                        return '#FFFF33'
                        break;

                }
            }
        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/sai/jiaolianCertList', that.params, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.params.pageNo += 1;
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.params.pageNo')

                if (this.params.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },

            onDownload(item){
                let that = this;
                that.certLoading = true;
                that.$api.post('/api/sai/getJlCert', {
                    member_id:item.id
                }, (res) => {
                    console.log(res);
                    that.certLoading = false;
                    that.showCert = true;
                    that.certUrl = res.data.url;
                    that.filename = res.data.filename;
                }, (res) => {
                    that.certLoading = true;
                    Toast.fail(res.msg);
                })
            },
            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },
            appDownload(){
                let that = this;
                console.log('downloadPic');
                appEvent({
                    name: 'downloadPic',
                    query: {
                        filename: that.filename+'.jpg',
                        url:that.certUrl,
                    }
                });
            },
            submit(){

            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                that.saveLoading = true;
                that.$api.post('/api/sai/jiaolianCertList', that.params, (res) => {
                    that.saveLoading = false;
                    that.addShow = false;
                    that.haveResult = true
                    that.onRefresh();
                }, (res) => {
                    Toast.fail(res.msg);
                    that.haveResult = false
                    that.saveLoading = false;
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// JiaolianList.vue?6cc29cc1